// extracted by mini-css-extract-plugin
module.exports = {"select":"TaxMaps_select__RS0VT","button":"TaxMaps_button__2XD3s","input":"TaxMaps_input__3361D","drivers":"TaxMaps_drivers__2YJOe","large":"TaxMaps_large__2lUZ-"};